"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.mapDispatchToProps = exports.mapStateToProps = void 0;
var React = require("react");
var react_redux_1 = require("react-redux");
var recompose_1 = require("recompose");
var sok_ui_1 = require("@caddigital/sok-ui");
var translation_1 = require("@caddigital/sok-reducers/lib/utils/translation");
var types_1 = require("types");
var projectWizardActions = require("@caddigital/sok-reducers/lib/actions/project/wizard");
require("./createEditCategory.scss");
var mapStateToProps = function (state) {
    return {
        category: state.project.wizard.step3.modal
    };
};
exports.mapStateToProps = mapStateToProps;
var mapDispatchToProps = function (dispatch) { return ({
    toggleModal: function () { return dispatch(projectWizardActions.toggleModal()); },
    updateName: function (_a) {
        var value = _a.target.value;
        return dispatch(projectWizardActions.deleteEditSetName(value));
    },
    updateGroup: function (name, id) { return function (e) { return (e.preventDefault(),
        dispatch(projectWizardActions.deleteEditCategoryRequest('EDIT', name, id))); }; }
}); };
exports.mapDispatchToProps = mapDispatchToProps;
//#region Types
var statePropsExtractable = (0, types_1.extractReturnType)(exports.mapStateToProps);
var dispatchPropsExtractable = (0, types_1.extractReturnType)(exports.mapDispatchToProps);
//#endregion
var enhance = (0, recompose_1.compose)((0, recompose_1.withState)('categoryName', 'setCategoryName', ''), (0, react_redux_1.connect)(exports.mapStateToProps, exports.mapDispatchToProps), recompose_1.pure);
function handleSaveText(props) {
    if (props.category.status === 'SAVING') {
        return React.createElement(sok_ui_1.LoadingSpinner, null);
    }
    return (0, translation_1.getLocalization)('userfront/order/addressbook/save');
}
exports.default = enhance(function (props) { return (React.createElement(sok_ui_1.Modal, { isOpen: props.category.status !== 'NONE' && props.category.type === 'CATEGORY', className: 'customer-wizard-modal-create-edit-category' },
    React.createElement(sok_ui_1.Header, { onClose: props.toggleModal }, (0, translation_1.getLocalization)('admin/projectsTab/editProject/modals/editCategory')),
    React.createElement("form", { onSubmit: props.updateGroup(props.categoryName, props.category.id) },
        React.createElement(sok_ui_1.Container, null,
            React.createElement("div", { className: 'content' },
                React.createElement("label", { htmlFor: 'groupname' }, (0, translation_1.getLocalization)('admin/projectsTab/editProject/modals/categoryName')),
                React.createElement(sok_ui_1.TextInput, { id: 'groupname', value: props.categoryName, className: 'white', placeholder: props.category.name, onChange: function (e) {
                        return props.setCategoryName(e.target.value.toString());
                    }, autoFocus: true }),
                props.category.status === 'FAILED' && (React.createElement("span", { className: 'request-failed' }, (0, translation_1.getLocalization)('admin/projectsTab/editProject/modals/unableToModifyCategory'))))),
        React.createElement(sok_ui_1.Footer, null,
            React.createElement(sok_ui_1.Button, { disabled: props.category.name.length === 0, text: handleSaveText(props), color: 'base-green', type: 'submit' }),
            React.createElement(sok_ui_1.Button, { text: (0, translation_1.getLocalization)('userfront/button/cancel'), color: 'dark-gray', onClick: props.toggleModal }))))); });
